import { configureStore } from '@reduxjs/toolkit'
import userReducer from './user/userReducer';
import confirmationReducer from './confirmation/confirmationReducer';
import alertReducer from './alert/alertReducer';

export const store = configureStore({
  reducer: {
    user: userReducer,
    confirmation: confirmationReducer,
    alert: alertReducer,
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware({
    serializableCheck: false,
  }),
})

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;